export default class CashFlowAttachmentDto {
    #encodedData;

    /**
     * Constructor.
     *
     * @param encodedData {string}
     */
    constructor(
        encodedData
    ) {
        this.#encodedData = encodedData;
    }

    get encodedData() {
        return this.#encodedData;
    }
}
